<template>
  <b-navbar
    class="public-navigation-menu"
    :class="mobileClasses"
  >
    <b-navbar-nav v-if="!isMobile">
      <component
        :is="keyToComponents[key]"
        v-for="({key}) in displayBtns"
        :key="key"
      />
      <b-nav-item-dropdown
        v-if="dropdownBtns.length > 0"
        no-caret
        lazy
        right
        toggle-class="p-0"
      >
        <template slot="button-content">
          <NavButton
            id="popover-button-sync"
            icon="bars"
            :label="navSettingsName"
            :image-src="imageSrc"
          />
        </template>
        <component
          :is="keyToComponents[key]"
          v-for="({key}) in dropdownBtns"
          :key="`list-nav-button-${key}`"
          list
        />
      </b-nav-item-dropdown>
    </b-navbar-nav>

    <b-navbar-nav
      v-else
      @click="$emit('click')"
    >
      <component
        :is="keyToComponents[key]"
        v-for="({key}) in mobileBtns"
        :key="key"
      />
    </b-navbar-nav>
  </b-navbar>
</template>

<script lang="ts">

import { VueConstructor } from 'vue'
import Component from 'vue-class-component'

import NavButton from '@/components/public/NavButtons/NavButton.vue'
import NavBtnBubblesMap from '@/components/public/NavButtons/NavBtnBubblesMap.vue'
import NavBtnSearch from '@/components/public/NavButtons/NavBtnSearch.vue'
import NavBtnFaq from '@/components/public/NavButtons/NavBtnFaq.vue'
import NavBtnDownload from '@/components/public/NavButtons/NavBtnDownload.vue'
import NavBtnFilterByCategory from '@/components/public/NavButtons/NavBtnFilterByCategory.vue'
import NavButtonsMixin from '@/mixins/NavButtonsMixin'

import { NavigationButtonConfig, NavigationButtonDisplays } from '@/types'
import {
  NAV_BTNS_CONFIG_KEY,
  SHOW_MAP_CONFIG_KEY,
  SEARCH_CONFIG_KEY,
  FAQ_CONFIG_KEY,
  DOWNLOAD_CONFIG_KEY,
  FILTER_BY_CATEGORY_KEY,
} from '@/constants'

const components = {
  NavButton,
}

const props = {
  isMobile: Boolean,
}

@Component({ components })
export default class NavButtons extends NavButtonsMixin.extend({ props }) {
  buttonConfig!: NavigationButtonConfig
  buttonEnabled!: (key: string) => boolean

  show = false

  get navSettingsName () {
    return this.$typedStore.activeVisualisation.visualisationStore.app.config.navigation.buttonName
  }

  get imageSrc () {
    return this.$typedStore.activeVisualisation.visualisationStore.entities.images.imageOrPreview(['config', NAV_BTNS_CONFIG_KEY, 'buttonIcon'])
  }

  get navSettings () {
    return Object.entries(this.buttonConfig)
      .map(([key, config]) => ({ ...config, key }))
  }

  get displayBtns () {
    return this.navSettings
      .filter(({ key, display }) => display === NavigationButtonDisplays.ON && this.buttonEnabled(key))
      .sort(({ order: first }, { order: second }) => {
        return first - second
      })
  }

  get dropdownBtns () {
    return this.navSettings
      .filter(({ key, display }) => display === NavigationButtonDisplays.DROPDOWN && this.buttonEnabled(key))
      .sort(({ order: first }, { order: second }) => {
        return first - second
      })
  }

  get mobileBtns () {
    return [
      ...this.displayBtns,
      ...this.dropdownBtns,
    ].filter(({ key }) => !(this.isMobile && key === SHOW_MAP_CONFIG_KEY))
  }

  get keyToComponents (): Record<string, VueConstructor> {
    return {
      [SHOW_MAP_CONFIG_KEY]: NavBtnBubblesMap,
      [SEARCH_CONFIG_KEY]: NavBtnSearch,
      [FAQ_CONFIG_KEY]: NavBtnFaq,
      [DOWNLOAD_CONFIG_KEY]: NavBtnDownload,
      [FILTER_BY_CATEGORY_KEY]: NavBtnFilterByCategory,
    }
  }

  get mobileClasses () {
    return this.isMobile ? ['p-0', 'my-n2'] : []
  }
}

</script>

<style>
.public-navigation-menu a.nav-link {
  color: inherit !important;
}
</style>
